import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, catchError, map, of, startWith } from 'rxjs';
import { ICroCodeResult } from '../interfaces/cro-result.interface';
import { FetchingState, RequestState } from '../interfaces/request.interface';
import { RegisterFormRequest, RegisterFormWithSenderIdsRequest } from '../interfaces/forms/register-form.interface';
import { toFormData } from '../components/signup/signup.utilities';
import { PublicFileResponse } from '../interfaces/public-file-response.interface';
import { SignUpFormResponse } from '../interfaces/forms/sign-up-form-response.interface';

const basePath = `/senderidregistry`;

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  http = inject(HttpClient);


  public submit$(body: RegisterFormWithSenderIdsRequest, file?: File): Observable<SignUpFormResponse> {
    return this.http.post<SignUpFormResponse>(`${basePath}/registration/signup`, toFormData(body, file));
  }

  public getPublicFile$(): Observable<PublicFileResponse> {
    return this.http.get(`${basePath}/registration/signup/template-file`, { responseType: 'arraybuffer', observe: 'response' }).pipe(
      map(({ body, headers }) => {
        const type = headers.get('content-type');
        const disposition = headers.get('content-disposition');
        const name = disposition?.split('filename=')?.[1].split(';')?.[0] ?? 'Organisation Documentation Template';
        return {
          blob: new Blob([body], { type }),
          name,
        };
      })
    );
  }
}
